export const compileNameOfProperty = <T>(name: keyof T) => name;

export const iOSBrowserNotificationAvailable = (): boolean => {
    const userAgent: string = navigator.userAgent;

    if (/iPhone/i.test(userAgent)) {
        const isSafariOrChromeOrEdge = /Safari/i.test(userAgent) || /CriOS/i.test(userAgent) || /Edg/i.test(userAgent);
        const isRunningFromHomeScreen = window.matchMedia("(display-mode: standalone)").matches;

        if (isSafariOrChromeOrEdge && !isRunningFromHomeScreen) {
            return false;
        }

        return true;
    }

    return true;
};
